__turbopack_context__.v({
  "appearance_in": "Modal-module-scss-module__iJZ71a__appearance_in",
  "appearance_out": "Modal-module-scss-module__iJZ71a__appearance_out",
  "backdrop": "Modal-module-scss-module__iJZ71a__backdrop",
  "backdrop-css-enter": "Modal-module-scss-module__iJZ71a__backdrop-css-enter",
  "backdrop-css-leave": "Modal-module-scss-module__iJZ71a__backdrop-css-leave",
  "backdrop-rendered": "Modal-module-scss-module__iJZ71a__backdrop-rendered",
  "backdrop__content": "Modal-module-scss-module__iJZ71a__backdrop__content",
  "backdrop__content--default": "Modal-module-scss-module__iJZ71a__backdrop__content--default",
  "backdrop__content--large": "Modal-module-scss-module__iJZ71a__backdrop__content--large",
  "backdrop__content--small": "Modal-module-scss-module__iJZ71a__backdrop__content--small",
  "backdrop__layer": "Modal-module-scss-module__iJZ71a__backdrop__layer",
  "body": "Modal-module-scss-module__iJZ71a__body",
  "dialog": "Modal-module-scss-module__iJZ71a__dialog",
  "dialog-css-enter": "Modal-module-scss-module__iJZ71a__dialog-css-enter",
  "dialog-css-leave": "Modal-module-scss-module__iJZ71a__dialog-css-leave",
  "dialog-rebound": "Modal-module-scss-module__iJZ71a__dialog-rebound",
  "dialog-rendered": "Modal-module-scss-module__iJZ71a__dialog-rendered",
  "dialog__close__button": "Modal-module-scss-module__iJZ71a__dialog__close__button",
  "footer": "Modal-module-scss-module__iJZ71a__footer",
  "header": "Modal-module-scss-module__iJZ71a__header",
  "header__subtext": "Modal-module-scss-module__iJZ71a__header__subtext",
  "header__subtext--default": "Modal-module-scss-module__iJZ71a__header__subtext--default",
  "header__subtext--small": "Modal-module-scss-module__iJZ71a__header__subtext--small",
  "header__title": "Modal-module-scss-module__iJZ71a__header__title",
  "rebound_animation": "Modal-module-scss-module__iJZ71a__rebound_animation",
  "transition-enter": "Modal-module-scss-module__iJZ71a__transition-enter",
  "transition-leave": "Modal-module-scss-module__iJZ71a__transition-leave",
});
